import * as types from "./mutation_types"

export default {
    [types.RESET](state){
        Object.assign(state,{
            isLoading: false,
            created: null,
            showMessage: false,
            message: "",
            isCreated:false,
            isSuccess: false,
            currentItem: null,
            conversation: null,
        
        }
    
        )
    },
    [types.SET_TOGGLE_LOADING](state){
        Object.assign(state,{isLoading:!state.isLoading})
    },
    [types.SET_SHOW_LOADING](state){
        Object.assign(state,{isLoading:true})
    },
    [types.SET_HIDE_LOADING](state){
        Object.assign(state,{isLoading:false})
    },
    [types.SET_TOGGLE_MESSAGE](state){
        Object.assign(state,{showMessage:!state.showMessage})
    },
    [types.SET_SHOW_MESSAGE](state){
        Object.assign(state,{showMessage:true})
    },
    [types.SET_HIDE_MESSAGE](state){
        Object.assign(state,{showMessage:false})
    },
    [types.SET_TOGGLE_MODAL](state){
        Object.assign(state,{showModal:!state.showModal})
    },
    
    [types.SET_IS_SUCCESS](state){
        Object.assign(state,{isSuccess:true})
    },
    [types.SET_IS_ERROR](state){
        Object.assign(state,{isSuccess:false})
    },
    [types.SET_MESSAGE](state,message){
        Object.assign(state,{message})
    },
    [types.SET_CREATED](state,created){
        Object.assign(state,{created})
    },
    [types.SET_CURRENT_ITEM](state,currentItem){
        Object.assign(state,{currentItem})
    },
    [types.SET_IS_CREATED](state){
        Object.assign(state,{isCreated:true})
    },
    [types.SET_NOT_CREATED](state){
        Object.assign(state,{isCreated:false})
    },
    [types.SET_CONVERSATION](state,conversation){
        Object.assign(state,{conversation})
    },
}